import { useState } from "react";
import { useServerFn } from "@tanstack/react-start";
import { toast } from "sonner";
import { createPortalSession } from "@/utils/payments.functions";
import { getStripeEnvironment } from "@/lib/stripe";

export function useManageSubscription() {
  const openPortal = useServerFn(createPortalSession);
  const [loading, setLoading] = useState(false);

  async function manage() {
    setLoading(true);
    try {
      const result = await openPortal({
        data: {
          environment: getStripeEnvironment(),
          returnUrl: `${window.location.origin}/app`,
        },
      });
      if ("error" in result) {
        toast.error(result.error);
        return;
      }
      window.open(result.url, "_blank");
    } catch (err) {
      toast.error((err as Error).message || "Couldn't open billing portal.");
    } finally {
      setLoading(false);
    }
  }

  return { manage, loading };
}
